<template lang="html">
  <div class="ctx">
    <div class="text-primary mb-2">Rapport</div>
    <textarea
      class="form-control"
      rows="6"
      :placeholder="text === null ? 'Écrire le rapport' : ''"
      v-model="text"
      ref="text"
    ></textarea>
    <div class="d-grid gap-2 d-md-flex justify-content-between mt-3">
      <a :href="reportsLink" v-if="establishment != undefined" target="_blank">
        <button type="button" class="btn btn-sm btn-outline-primary mt-2">
          Voir l'historique
        </button>
      </a>

      <button type="button" class="btn btn-sm btn-primary mt-2" @click="saveText()">Enregistrer</button>
    </div>
  </div>

</template>

<script>
import settings from '@/settings.coffee';
import {gqlQuery, gqlMutation} from '@/gqlClient.js';
import NEXT_REPORT_TEXT from '@/gql/queries/nextReportText.graphql'
import SAVE_REPORT_TEXT from '@/gql/mutations/saveNextReportText.graphql'

export default {
  name: "TextForNextReport",
  props: {
    establishment: {
      default: null
    }
  },
  data() {
    return {
      text: null,
      loading: false,
      lastReportPublished: false
    };
  },
  computed: {
    reportsLink() {
      return settings.backendUrl + "/admin/establishment/establishmentreport/?establishment__uid__exact=" + (this.establishment ? this.establishment.uid : "");
    }
  },
  methods: {
    getText() {
      const self = this;
      self.loading = true;
      self.text = null;
      gqlQuery(NEXT_REPORT_TEXT, {
        establishment_uid: self.establishment.uid
      }).then(function (resp) {
        self.loading = false;
        if (resp.body.data.establishment_report_set.length > 0) {
          const lastReport = resp.body.data.establishment_report_set[0];
          console.log(lastReport.published);
          self.lastReportPublished = lastReport.published;
          self.text = lastReport.published ? null : lastReport.custom_text;
        } else {
          self.lastReportPublished = true;
          self.text = null;
        }
        self.$store.commit("delete_edited_fields", {
          key: "TextForNextReport.text"
        });
      })
          .catch(function () {
            self.loading = false;
          });
    },
    saveText() {
      const self = this;
      self.loading = true;
      gqlMutation(SAVE_REPORT_TEXT, {
        establishment_uid: self.establishment.uid,
        custom_text: self.text.replace(/"/g, "'").replace(/\n/g, "\\n")
      }).then(function () {
        self.loading = false;
        self.$store.commit("delete_edited_fields", {
          key: "TextForNextReport.text"
        });
      })
          .catch(function () {
            self.loading = false;
          })
    }
  },
  mounted() {
    this.getText();
  },
  watch: {
    'establishment.uid': function (newV) {
      if (newV) {
        this.getText();
      }
    },
    text: function (newV, oldV) {
      if (oldV !== null && typeof oldV !== "undefined") {
        this.$store.commit("update_edited_fields", {
          key: "TextForNextReport.text",
          value: newV,
          verbose_name: "Texte pour le prochain rapport",
          el: this.$refs.text
        });
      }
    }
  }
};
</script>

<style scoped>
.textarea {
  height: 100%;
}
</style>
